import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import FireSecurityUnitInfoComponent from "./fireSecurityUnitInfoComponent";

const FireSecurityUnitCheckModal = ({ isOpen, onClose, unit }: any) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      shouldBlockScroll={true}
      isDismissable={true}
      scrollBehavior="inside"
      backdrop="blur"
      className="p-8"
    >
      <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
        <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
          <p>{unit.id} - Brandveiligheid</p>
        </ModalHeader>
        <ModalBody className="px-0">
          <FireSecurityUnitInfoComponent
            fireSecurityUnitInfo={{ ... unit?.fireSecurityUnitInfo, unitId: unit.id}}
            handleCloseParent={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FireSecurityUnitCheckModal;
